import axios from "axios";

export const getConversations = async () => {
  const { data } = await axios.get("/api/conversations");
  return data;
};

// Oversight: every conversation in the school (Admin/Management/SuperAdmin).
// Access is audit-logged server-side.
export const getAllConversations = async () => {
  const { data } = await axios.get("/api/conversations/all");
  return data;
};

export const getConversation = async (id) => {
  const { data } = await axios.get(`/api/conversations/${id}`);
  return data;
};

export const createConversation = async (participantIds) => {
  const { data } = await axios.post("/api/conversations", { participantIds });
  return data;
};

export const markConversationRead = async (id) => {
  const { data } = await axios.post(`/api/conversations/${id}/mark-read`);
  return data;
};

export const getContacts = async () => {
  const { data } = await axios.get("/api/conversations/contacts");
  return data;
};

export const getMessages = async (conversationId, params) => {
  const { data } = await axios.get(`/api/conversations/${conversationId}/messages`, { params });
  return data;
};

export const sendMessage = async (conversationId, payload) => {
  const { data } = await axios.post(`/api/conversations/${conversationId}/messages`, payload);
  return data;
};
